import { IAdminSupplementInquiryDetailsDto } from './adminSupplements';
import { IFetchListRequestPayload, IFetchListRequestProps, IIdentity, ITableData } from './common';

export enum TAdminInquiriesPageTab {
  Pending,
  Sent,
}

export interface IAdminSearchInquiriesProps extends IFetchListRequestProps {
  isPending: boolean;
}

export interface IAdminSearchInquiriesPayload {
  isPending: boolean;
  pagedResultsRequest: IFetchListRequestPayload;
}

export interface IAdminInquiryDetails extends IIdentity {
  adminSupplementInquiryDetailsDto: IAdminSupplementInquiryDetailsDto[];
  inquiryStatusId: number;
  organizationId: number;
  programCodeId: number;
  submittedOn: string;
  timeElapsed: string;
}

export type IAdminInquiriesTableData = ITableData<IAdminInquiryDetails>;
